import { fetchGet } from '@par/shared/api/common';
import { Profile } from '@par/shared/types/player';
import { aveColor } from '../common/lookups';
import { compact, orderBy } from 'lodash';
import { TableRowType } from '../types/custom-questions';

export const fetchProfileById = async (profileId: string) =>
  await fetchGet(`/profile/id/${profileId}`);

export const fetchAchievements = async (profileId: string) =>
  await fetchGet(`/achievements/user/${profileId}`);

export const calcAvesPer100 = (
  aveCount: number,
  questionsSeenCount: number
) => {
  if (!aveCount) return '';
  const val = (aveCount / questionsSeenCount) * 100;
  return val.toFixed(1);
};

export const avesData = (viewProfile: Profile) => {
  const { aves, questionsSeenCount } = viewProfile;

  return [
    {
      name: 'PAR',
      lifeTime: aves['par'],
      per100Qs: calcAvesPer100(aves['par'], questionsSeenCount),
      color: aveColor('par'),
    },
    {
      name: 'Birdie',
      lifeTime: aves['birdie'],
      per100Qs: calcAvesPer100(aves['birdie'], questionsSeenCount),
      color: aveColor('birdie'),
    },
    {
      name: 'Eagle',
      lifeTime: aves['eagle'],
      per100Qs: calcAvesPer100(aves['eagle'], questionsSeenCount),
      color: aveColor('eagle'),
    },
    {
      name: 'Albatross',
      lifeTime: aves['albatross'],
      per100Qs: calcAvesPer100(aves['albatross'], questionsSeenCount),
      color: aveColor('albatross'),
    },
    {
      name: 'Condor',
      lifeTime: aves['condor'],
      per100Qs: calcAvesPer100(aves['condor'], questionsSeenCount),
      color: aveColor('condor'),
    },
    {
      name: 'Ostrich',
      lifeTime: aves['ostrich'],
      per100Qs: calcAvesPer100(aves['ostrich'], questionsSeenCount),
      color: aveColor('ostrich'),
    },
    {
      name: 'Pterodactyl',
      lifeTime: aves['pterodactyl'],
      per100Qs: calcAvesPer100(aves['pterodactyl'], questionsSeenCount),
      color: aveColor('pterodactyl'),
    },
  ];
};

export const getSeenProgessValue = (
  tableRows: TableRowType[],
  seenCount: number
) => {
  const orderedBySeen = compact(
    orderBy(tableRows, 'seen', 'desc').map((el) => el.seen)
  );
  const mostSeenValue = orderedBySeen[0];
  return (mostSeenValue ? seenCount / mostSeenValue : 0) * 100;
};
